exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "td{font-size:14.5px!important}.input-group-append>.input-group-text,td.form-group>input[type=number],td>.select2-container--default .select2-selection--single .select2-selection__rendered{padding-left:5px!important;padding-right:5px!important}@media print{@page{size:A4 landscape;margin-top:20px;margin-bottom:20px;margin-left:15px;margin-right:15px}body{transform:scale(.73)!important;transform-origin:top left!important;min-width:2250px!important;overflow-y:scroll!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./App/Components/Borrow/UpdateBorrowProduct.vue
// module id = 1098
// module chunks = 0